module.exports = __webpack_public_path__ + "img/view.ec46c210.svg";